export default function isAbortError(error: unknown): boolean {
  // Duck-typed on purpose: only Chromium subclasses DOMException from Error.
  // Firefox and Safari throw a spec-compliant DOMException that fails
  // `instanceof Error`, so that check alone silently lets their AbortErrors
  // (and other browsers' equivalents) through as unfiltered exceptions.
  return (
    typeof error === 'object' &&
    error !== null &&
    'name' in error &&
    (error as { name?: unknown }).name === 'AbortError'
  );
}
